export const IfItem = ({ items, render, elseTemplate }) =>
  items instanceof Array && items?.length
    ? render(items)
    : elseTemplate || <p>No domains Found!</p>;
